export default class LangMenuComponent {
    constructor() {
        LangMenuComponent.langsSwitcher()
    }

    static langsSwitcher() {
        const current_lang = $('.header__tools__item__languages__current')
        const list_langs = $('.header__tools__item__languages__langs')

        //On init
        $(window).on('load', () => {
            window.setTimeout(() => {
                let current_language = $('html').attr('lang').replace(/-.*/gi, '')
                if (current_language === 'auto') {
                    current_language = 'fr'
                }

                $('.header__tools__item__languages__langs > a').each(function () {
                    if ($(this).text().toUpperCase() === current_language.toUpperCase()) {
                        $(this).hide()
                    }
                })

                $(current_lang).text(current_language)
            }, 500)
        })

        //Open submenu
        $(current_lang).on('click', () => {
            $(list_langs).toggleClass('header__tools__item__languages__langs--open')
        })

        //Select lang
        $(list_langs).on('click', () => {
            $(list_langs).toggleClass('header__tools__item__languages__langs--open')
        })

        //Change Navbar Language on click
        $('.header__tools__item__languages__langs > a').on('click', function () {
            $('.header__tools__item__languages__langs > a').show()
            $(this).hide()
            $(current_lang).text($(this).text())
        })
    }
}
